import { BaseContext } from "src/com/sixdee/crbtportal/utils/basecontext";
import { UIComponentHandler, UIDataModel } from "../../../../toolkit/uicomponent";
import { UIComponentViewImpl } from "../../../../toolkit/uicomponentview";
import { FlashMessageSubscriptionDetailsComponentProps, FlashMessageSubscriptionDetailsComponentState, FlashMessageSubscriptionDetailsHandler } from "./flashmessagesubscriptiondetailscomponent";
import { FlashMessageSubscriptionDetailsCSSStyle } from "./flashmessagesubscriptiondetailscss";
import * as React from "react";
import { LoaderWrapperComponent } from "../../../popup/loaderwrappercomponent";
import { PopUpWrapperComponent } from "../../../popup/popupwrappercomponent";
import { AlertType } from "../../../../toolkit/alert/alerttype";
import { Strings } from "src/com/sixdee/crbtportal/utils/resources/strings";
import { AlertComponent } from "../../../../toolkit/alert/alertcomponent";
import { LoaderComponent } from "../../../../toolkit/loader/loadercomponent";
import './flashmessagesubscription-style.css';
import './flashmessagecurrent-style.css';
import { SwitchComponent } from "../../../../toolkit/switch/switchcomponent";
import { SwitchCSSStyleImpl } from "../../../../toolkit/switch/switchcss";
import { ButtonComponent } from "../../../../toolkit/button/buttoncomponent";
import { ConfirmRequestConfirmButtonCSSStyleImpl } from "../../../popup/confirmrequest/confirmrequestconfirmbuttoncss";
import { RoutingFeatures } from "../../../navigation/routingfeature";

export class FlashMessageSubscriptionDetailsViewImpl extends UIComponentViewImpl<UIDataModel> 
{  
    private loaderWrapperComponent:LoaderWrapperComponent;
    private popUpComponent: PopUpWrapperComponent;
    private switchComponent: any;

    constructor(context: BaseContext, handler: UIComponentHandler)
    {
        super(context, handler);
    }

    bindHandlers()
    {
        this.closePopup = this.closePopup.bind(this);
        this.showPopup = this.showPopup.bind(this);
        this.onUnsubscribeClicked = this.onUnsubscribeClicked.bind(this);
        this.onPlayPauseClicked = this.onPlayPauseClicked.bind(this);
        this.onDeleteClicked = this.onDeleteClicked.bind(this);
        this.onShowDedicate = this.onShowDedicate.bind(this);
    }

    draw(props: FlashMessageSubscriptionDetailsComponentProps, state: FlashMessageSubscriptionDetailsComponentState, cssStyle: FlashMessageSubscriptionDetailsCSSStyle): JSX.Element | boolean
    {
        super.draw(props, state, cssStyle);
        return (
            <>
              <div id="flash-subscription-card-wrapper">
                                {
                                    this.getWebView(props, state, cssStyle)
                                }
                    </div>
            <PopUpWrapperComponent ref={(item: any) => this.popUpComponent = item} context={props.context}/>
            <LoaderWrapperComponent ref={(item: any) => this.loaderWrapperComponent = item} context={props.context}/>
            </>
        );
    }


    getWebView(props: FlashMessageSubscriptionDetailsComponentProps, state: FlashMessageSubscriptionDetailsComponentState, cssStyle: FlashMessageSubscriptionDetailsCSSStyle)
    {
        // props.context.getUserContext().getIsLoggedIn() && state.isSubscribed
        return (
            <>
             {props.context.getUserContext().getIsLoggedIn() && state.isSubscribed &&
             <>
           <div id="flashmessage-main">
            <div id="flashmessage-subscription-details-main-wrapper" >
                <div id="flashmessage-subscription-details-div" style={{}}>
                        <label id="flashmessage-subscription-details-div-label" style={{}}>
                            {this.getContext().getResources().getString(Strings.my_subscription_plan)}
                        </label>
                        <label id="flashmessage-subscription-details-status" style={{}}>
                            {state.isStatusActive ? this.getContext().getResources().getString(Strings.pause)
                            : this.getContext().getResources().getString(Strings.resume)}
                        </label>
                    <SwitchComponent ref={(item:any) =>{this.switchComponent = item;}} onChange={this.onPlayPauseClicked} style={new SwitchCSSStyleImpl(this.getContext())} isChecked={state.isStatusActive} context={this.getContext()}/>
                </div>
                <div id="flashmessage-subscription-details-card-div" style={{backgroundImage: "url('" + this.getContext().getResources().getImage("flash_message_grey.png") + "')"}}>
                     <div id="flashmessage-subscription-details-card-planname-div">
                        <label id="flashmessage-subscription-details-card-planname-label1" style={{}}>
                            {state.packName}
                        </label>
                        <label id="flashmessage-subscription-details-card-planname-label2" style={{}}>
                            {this.getContext().getResources().getString(Strings.expiring_on) + state.expiryDate}
                        </label>
                     </div>
                        
                     <div id="flashmessage-subscription-details-unsubscribe">
                          <ButtonComponent onClick={this.onUnsubscribeClicked} style={new ConfirmRequestConfirmButtonCSSStyleImpl(props.context)} context={props.context} label={props.context.getResources().getString(Strings.unsubscribe)}/>
                    </div>
                </div>
            </div>
            {state.isCurrentFlashMessageAvailable &&
            <div id="flashmessagecurrent-main-wrapper" >
                <div id="flashmessagecurrent-div" style={{}}>
                        <label id="flashmessagecurrent-div-label" style={{}}>
                            {this.getContext().getResources().getString(Strings.current_flash_message)}
                        </label>
                </div>
                <div id="flashmessagecurrent-card-div" style={{backgroundImage: "url('" + this.getContext().getResources().getImage("flash_message_blue.svg") + "')"}}>
                    <div id="flashmessagecurrent-card-img">
                        <img height="130px" width="48px" src={props.context.getResources().getImage("quotes.svg")}/>
                     </div>
                     <div id="flashmessagecurrent-card-message-div">
                        <label id="flashmessagecurrent-card-message-label1" style={{}}>
                            {state.currentFlashMessage}
                        </label>
                     </div>
                     <div id="flashmessagecurrent-card-delete-img" onClick={this.onDeleteClicked}>
                        <img height="28px" width="28px" src={props.context.getResources().getImage("delete.svg")}/>
                     </div>
                </div>
            </div> 
            }      
            {state.isSubscribed &&
            <div id="flashmessagecurrent-main-wrapper1">
                <div id="flashmessagecurrent-div" >
                        <label id="flashmessagecurrent-div-label" style={{}}>
                            {this.getContext().getResources().getString(Strings.dedicate_flash_message)}
                        </label>
                </div>
                <div id="flashmessagecurrent-card-div" style={{backgroundImage: "url('" + this.getContext().getResources().getImage("flash_message_blue.svg") + "')"}}>
                    <div id="flashmessagecurrent-card-img">
                        <img height="130px" width="48px" src={props.context.getResources().getImage("quotes.svg")}/>
                     </div>
                     <div id="flashmessagecurrent-card-message-div">
                        <div id="flashmessage-subscription-details-dedicate">
                            <ButtonComponent onClick={this.onShowDedicate} style={new ConfirmRequestConfirmButtonCSSStyleImpl(props.context)} context={props.context} label={props.context.getResources().getString(Strings.show_dedicate)}/>
                        </div>
                     </div>
                   
                </div>
            </div> 
            }      
           </div>   
           </>  
    }
    
           </>
        );
    }


    showLoader()
    {
       
        this.loaderWrapperComponent !== null && this.loaderWrapperComponent.setShowWindow(true,  <LoaderComponent context={this.getUIProps().context}/>);   
    }
  
    dismissLoader()
    { 
        this.loaderWrapperComponent !== null && this.loaderWrapperComponent.setShowWindow(false, <></>);
    }

    protected closePopup()
    {
        this.popUpComponent !== null && this.popUpComponent.setShowWindow(false, <></>);
    }

    onUnsubscribeClicked()
    {
        (this.getUIComponentHandler() as  FlashMessageSubscriptionDetailsHandler).onUnSubscribeClicked();
    }

    onPlayPauseClicked(isChecked: boolean)
    {
        console.log("onPlayPauseClicked() ");
        (this.getUIComponentHandler() as  FlashMessageSubscriptionDetailsHandler).onStatusChcnge(isChecked);
    }
   
    onDeleteClicked()
    {
        (this.getUIComponentHandler() as  FlashMessageSubscriptionDetailsHandler).onDeleteClick();
    }
    onShowDedicate()
    {
        this.getUIProps().context.getRedirectionHandler().routeNextFeature(RoutingFeatures.DEDICATE_FLASH_MESSAGE, false);
    }
    showPopup(id:string,msg:string,type:AlertType):void
    {
        this.closePopup();
         
         this.popUpComponent !== null && this.popUpComponent.setShowWindow(true, <AlertComponent buttonTitle={this.getContext().getResources().getString(Strings.ok)} alertMessage={msg} alertType={type} onCloseButtonClick={this.closePopup} onClick={this.closePopup} context={this.getUIProps().context}/>);
    }

    updatePlayPause()
    {
        this.switchComponent !== null &&
        this.switchComponent.updateShuffle();
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/flashmessage/flashmessagesubscriptiondetails/flashmessagesubscriptiondetailsview.tsx